<app-modal-header [isShowCloseBtn]="true" (closeModal)="close()"></app-modal-header>
<div class="chat-content">
  @if (isLoading()) {
    <div class="chat-status d-flex justify-content-center align-items-center">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
  @if (loadError()) {
    <div class="chat-status d-flex flex-column justify-content-center align-items-center text-center">
      <i class="bi bi-exclamation-triangle text-danger display-4"></i>
      <p class="mt-3">{{ 'SOMETHING_WENT_WRONG' | translate }}</p>
      <button class="btn d-inline btn-light rounded-5 fw-medium ms-1" (click)="retryLoad()">
        {{ 'RETRY' | translate }}
      </button>
    </div>
  }
  <div #jubliaContainer [class.d-none]="isLoading() || loadError()" class="chat-mount"></div>
</div>
